import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { CaseFundsService } from '../../../../shared/services/case-funds.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-fund',
  templateUrl: './add-fund.component.html',
  styleUrls: ['./add-fund.component.scss']
})
export class AddFundComponent implements OnInit {

   @Input() caseId: number = -1;

  newFundDetails = this.fb.group({
    description: ['', Validators.required],
    net: [null, Validators.required],
  }, { });

  constructor(
              private fb: UntypedFormBuilder,
              private caseFundsService: CaseFundsService,
              public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  addFund(){
    this.caseFundsService.addCaseFund( this.caseId,  this.newFundDetails.value ).subscribe((response : any) => {
      this.activeModal.close(true);
    });
  }

}
